export const getColorMaterial = (number) => {

    return number === 0 ? "success" : number === 1 ? "warning" : "error"
}